import BudgetTab from "./BudgetTab";

export default function FinancialManagementTab() {
  return <BudgetTab moduleMode="finance" />;
}
